<template>
	<div ref="forclosure" v-parallax-fit="parallax" class="forclosure">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/19_ForeclosureLetter@2x.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';
export default {
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/ozzie/3.srt',
				'es': '/themes/rise-theme/resources/assets/audio/ozzie/3_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 26000,
					end: 28000,
					fromStyle: { transform: 'translateY(-500%) rotate(0deg)' },
					toStyle: { transform: 'translateY(0%) rotate(0deg)' },
					easing: 'linear'
				},
				{
					start: 30000,
					end: 33000,
					fromStyle: { transform: 'translateY(0%) rotate(0deg)' },
					toStyle: { transform: 'translateY(500%) rotate(-45deg)' },
					easing: 'linear'
				}
			]
		}
	},
	mounted() {
		const audio = '/themes/rise-theme/resources/assets/audio/ozzie/OZZIE_PART4_010723.mp3';

		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/5a.png',
					url: 'https://poverty.umich.edu/publications/the-eviction-machine-neighborhood-instability-and-blight-in-detroits-neighborhoods/',
					link_title: {
						'en': "The Eviction Machine: Neighborhood Instability and Blight in Detroit’s Neighborhoods",
						'es': 'La máquina de desalojo: Inestabilidad y deterioro de los vecindarios en los vecindarios de Detroit'
					},
				},
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/5b.png',
					url: 'https://www.vice.com/en/article/7xwwx9/why-one-in-three-detroit-properties-has-been-foreclosed-on',
					link_title: {
						'en': "Why one in three Detroit properties have been foreclosed on in the last 15 years",
						'es': 'Por qué una de cada tres propiedades de Detroit ha sido embargada en los últimos 15 años'
					},
				}
			],
			text: {
				'en': '"As Detroit touts its comeback and celebrates its success in climbing out of the largest municipal bankruptcy in American history, many of the city’s residents remain on the brink of displacement."',
				'es': '"Mientras Detroit promociona su regreso y celebra su éxito al salir de la bancarrota municipal más grande en la historia de Estados Unidos, muchos de los residentes de la ciudad siguen al borde del desplazamiento."'
			}
		};

		const text = {
			'en': "From 2005 to 2015, about half of all residential properties in the city of Detroit were forclosed on by the county tax assessor or banks. These properties were eventually sold in auctions to speculative investors. These investors then deferred maintenance, flipped the homes, or abandoned them, leading to widespread neighborhood instability and displacement.",
			'es': 'De 2005 a 2015, aproximadamente la mitad de todas las propiedades residenciales en la ciudad de Detroit fueron ejecutadas por el tasador de impuestos del condado o por los bancos. Estas propiedades finalmente se vendieron en subastas a inversores especulativos. Luego, estos inversionistas aplazaron el mantenimiento, cambiaron las casas o las abandonaron, lo que provocó una inestabilidad y un desplazamiento generalizados de los vecindarios.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateY(0%) rotate(0deg)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					this.$evidence.value = JSON.stringify(evidence);
					this.$readMore.value = text;
				}
			});
		});

		this.mutationObserver.observe(this.$refs.forclosure, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.forclosure {
	position: absolute;
	right: 0;
	top: 0;
	transition: all 0.6s linear;
	width: 650px;
	margin-right: -85px;
	margin-top: -90px;
}

@media screen and (max-width: 1600px) {
	.forclosure {
		width: 595px;
	}
}

@media screen and (max-width: 991px) {
	.forclosure {
		width: 480px;
		margin-right: -76px;
		margin-top: -50px;
	}
}

@media screen and (max-width: 650px) {
	.forclosure {
		width: 330px;
		margin-right: -52px;
		margin-top: -40px;
	}
}
</style>
